module.exports = __webpack_public_path__ + "static/img/bcg.0024ea21.webp";